import {addDays} from "date-fns";

export const getHistoryFromDate = (historyLimit: number | null): Date => {
    return addDays(new Date(), historyLimit === null ? -31 : (historyLimit === -1 ? -3650 : -historyLimit));
}